import { createContext } from 'react';

export type FeatureFlags = {
  canUseChat: boolean;
  canViewAdminUI: boolean;
  canViewHistory: boolean;
};

export type FeatureSettings = FeatureFlags & {
  canUseChat: boolean;
  canViewAdminUI: boolean;
  canViewHistory: boolean;
  hasFeature: (feature: string) => boolean;
  loading: boolean;
};

export type FeatureFlag = keyof FeatureFlags;

export const FeatureContext = createContext<FeatureSettings>({
  canUseChat: false,
  canViewAdminUI: false,
  canViewHistory: false,
  hasFeature: () => false,
  loading: false,
});
